import React, { useEffect, useState } from 'react';
import Input from '../../components/general/input/Input';
import Button from '../../components/general/button/ButtonMinimalist';
import HelpIcon from '../../assets/images/mini/question_red.png';
import CompanyLogo from '../../assets/images/NicoLetrasAniversario.webp';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, onAuthStateChanged, sendEmailVerification } from 'firebase/auth';
import { getDatabase, ref, set } from 'firebase/database';
import Footer from '../../components/general/footer/Footer';
import { database } from '../../firebase/Firebase';
import ProductosBanner from '../../assets/images/banners/webps/interior2.webp'
import { Helmet } from 'react-helmet';

export default function Register() {

  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [tel, setTel] = useState("");
  const [dni, setDNI] = useState("");
  const [localidad, setLocalidad] = useState("");
  const [email, setEmail] = useState("");
  const [logError, setLogError] = useState("");
  const [load, setLoad] = useState(false);

  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if(firstLoad){
      //onAuthStateChanged(auth, handleUserStateChange);
    }
  })

  function handleUserStateChange(user){
    if(user){
      navigateTo("/")
    }else{
      console.log("No hay nadie autenticado.. ")
    }
  }

  let navigate = useNavigate();

  function navigateTo(path){
    navigate(path);
  }

  function registerUser(){
    let correctedEmail = email.toLowerCase();
    correctedEmail.replace(" ", "");
    if(email === "" || nombre === "" || apellido === "" || tel === "" || dni === "" || localidad === ""){
      setLogError("Por favor, complete todos los campos");
    }else if(email.match(/@/i) == null && email.match(/./i) == null){
      setLogError("Inserte un email valido");
      console.log(email);
    }else if(email !== "" && nombre !== "" && apellido !== "" && tel !== "" && dni !== "" && localidad !== ""){
      set(ref(getDatabase(), "solicitudes/"+dni), {
        nombre: apellido+" "+nombre,
        email: email,
        telefono: tel,
        fecha: new Date().getTime(),
        dni: dni,
        localidad: localidad
      }).catch((error) => {
        console.error(error)
      })
      navigateTo("completed")
    }
  }

  const metaTags = {
    title: "Registro para técnicos",
    description: "Nicolini Refrigeración es un empresa dedicada a la venta, instalación y reparación de equipos de frío para camiones y utilitarios. Además cuenta con venta de insumos y repuestos para refrigeracion familiar, comercial y del automotor",
    url: "https://www.nicolinirefrigeracion.com.ar/register"
  }

  return (
    <div className='Register'>

      <Helmet>
        <title>{metaTags.title}</title>
        <meta name="description" content={metaTags.description} />
        
        <meta property="og:site_name" content={metaTags.title} />
        <meta property="og:title" content={metaTags.title} />
        <meta property="og:description" content={metaTags.description} />
        <meta property="og:image" content={ProductosBanner} />
        <meta property="og:url" content={metaTags.url} />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content={metaTags.title} />
        <meta name="twitter:description" content={metaTags.description} />
        <meta name="twitter:image" content={ProductosBanner} />
      </Helmet>

        <div className='register-page'>
            <img src={CompanyLogo}/>
            <h2>Registrarse</h2>
            <Input title="Nombre/es" setInput={setNombre} placeholder={"Nombre"}/>
            <Input title="Apellido/s" setInput={setApellido} placeholder={"Apellido"}/>
            <Input title="Telefono" setInput={setTel} type="phone" placeholder={"3434178703"}/>
            <Input title="DNI" setInput={setDNI} type="number" max={99999999} placeholder={"12345678"}/>
            <Input title="E-Mail" setInput={setEmail} placeholder={"ejemplo@email.com"}/>
            <Input title="Localidad" setInput={setLocalidad} placeholder={"Crespo"}/>
            
            <p className='error-message'>{logError !== "" && <img className="mini-icon" src={HelpIcon} alt="Error"/>}{logError !== "" && logError}</p>
            <Button text="Registrarme" onClick={() => registerUser()}/>
        </div>
        <Footer />
    </div>
  )
}
